import { css } from "@vitality-ds/system";

// eslint-disable-next-line import/prefer-default-export
export var BaseAdornmentWrapperStyles = css({
  display: "flex",
  alignItems: "flex-start",
  flexShrink: 0,
  alignSelf: "center",
  lineHeight: 1
});